import { render } from "./HostingComponent.vue?vue&type=template&id=3220c545&scoped=true"
import script from "./HostingComponent.vue?vue&type=script&lang=js"
export * from "./HostingComponent.vue?vue&type=script&lang=js"

import "./HostingComponent.vue?vue&type=style&index=0&id=3220c545&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3220c545"]])

export default __exports__